/**
 * Ruta de cobro de un medio de pago según el contexto del checkout.
 *
 * Regla:
 * - `efectivo` siempre cobra en efectivo.
 * - `mercado_pago` (link/online) siempre va al checkout de Mercado Pago.
 * - En la carta / tótem web público **todo** cobro de Mercado Pago usa la preferencia oficial,
 *   porque no hay terminal ni QR del local (el tótem es web).
 * - En el panel de caja (`isDashboard`) el QR se cobra contra la terminal del local, aunque el
 *   tótem sea web: el cajero necesita el QR estático visible en el modal.
 */
export type CheckoutMethodRoute = 'cash' | 'mp_link' | 'qr' | 'card';

export function resolveCheckoutMethodRoute(params: {
  methodType: string;
  isDashboard: boolean;
  isWebTotem: boolean;
}): CheckoutMethodRoute {
  const { methodType, isDashboard, isWebTotem } = params;

  if (methodType === 'efectivo') return 'cash';
  if (methodType === 'mercado_pago') return 'mp_link';
  if (!isDashboard && isWebTotem) return 'mp_link';
  if (methodType === 'qr') return 'qr';

  return 'card';
}
